module.exports = __webpack_public_path__ + "static/media/live_icons.eeb4354c.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Implementation/img/live_icons.png
// module id = 171
// module chunks = 0